import styled, { css } from 'styled-components'
import { SidebarState } from './PageLayout'
import { FadeIn } from '../../styles/base.styles'
import { paddingStyles } from '../../styles/sizes'

type PageLayoutContainerProps = {
  sidebarState: any
}

function getPageLayoutContainerPadding(
  sidebarState: keyof typeof SidebarState,
) {
  switch (sidebarState) {
    case 'folded':
      return css`
        padding: 0 0 0 60px;
      `
    case 'disabled':
      return css`
        padding: 0;
      `
    case 'expanded':
    default:
      return css`
        padding: 0 0 0 156px;
        @media(max-width: 1500px) {
          padding: 0 0 0 140px;
        }
      `
  }
}

export const PageLayoutContainer = styled.div<PageLayoutContainerProps>`
  min-height: 100%;
  position: relative;
  background-color: ${(props) => props.theme.colors.primary};
  //animation: ${FadeIn} .5s;
  transition: all .1s;

  ${(props) => getPageLayoutContainerPadding(props.sidebarState)}
`
export const PageLayoutMain = styled.div<{sidebar: boolean, hasOffset?: boolean, noScroll?: boolean, hasGradient?: boolean}>`
  border-radius: ${(props) => props.sidebar ? '.8rem' : 0} 0 0 0;
  background: ${props => props.hasGradient ? 'linear-gradient(#ffffff,#f2e8ff)' : '#f9f8fa'};
  position: relative;
  //overflow: hidden;
  z-index: 1;
  display: flex;
  flex-direction: column;
  
  ${props => props.noScroll ? css`
    height: calc(100vh - 4rem);
  ` : css`
    min-height: ${props.hasOffset ? 'calc(100vh - 4rem)' : '100vh'};
  `}
`

export const PageLayoutSidebar = styled.div<{disabled?: boolean, isFolded: boolean}>`
  position: fixed;
  top: 0;
  left: 0;
  width: ${props => props.isFolded ? '60px' : '156px'};
  background-color: ${(props) => props.theme.colors.black};
  min-height: 100vh;
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};
  opacity: ${props => props.disabled ? 0.5 : 1};
  /* z-index: 3; */
  transition: width .1s;
  overflow: hidden;
  
  @media(max-width: 1500px) {
    width: ${props => props.isFolded ? '60px' : '140px'};
  }
`

export const BackButton = styled.button<{navbar: boolean}>`
  background: white;
  position: absolute;
  z-index: 9;
  top: ${(props) => props.navbar ? 10 : 6.7}rem;
  left: ${(props) => props.navbar ? 2.7 : 1.35}rem;
  width: 2.7rem;
  height: 2.7rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 6px;
  border: 1px solid #D8D8D8;
  cursor: pointer;
  transform: rotate(-180deg);
  
  // @media(max-width: 1366px) {
  //   top: ${(props) => props.navbar ? 156 : 96}px;
  //   left: 24px;
  // }
`;

export const PageContainer = styled.div`
  ${paddingStyles.p}
`;

export const TabNavContainer = styled.div`
  position: relative;
  z-index: 1000;
`
